import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Galerie } from '@components/galerie/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { Image } from '@shared/components/image/models';
import { TitleComponent } from '@shared/components/title';
import { VideoComponent } from '@shared/components/video';

@Component({
  selector: 'app-galerie-it2ivi',
  imports: [TitleComponent, ImageComponent, VideoComponent, ButtonComponent],
  templateUrl: './galerie-it2ivi.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalerieIt2iviComponent extends AbstractDynamicComponent<Galerie> {
  zoomImageRequested = output<Image>();
}
